import React from 'react'
import { connect } from 'react-redux'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'

import HeaderBox from 'client/shared/boxes/header-box'

import Meta from 'client/shared/blocks/meta'
import MetaTitle from 'client/shared/blocks/meta-title'
import { MetaDescription } from 'client/shared/blocks/meta-description'
import { withI18n } from '@lingui/react'

import { Location } from 'client/shared/types/react-router'
import { CurrentUserState } from 'client/shared/types/current-user'
import SpecialOfferUnavailable from 'client/bookmate/blocks/special-offer-unavailable'
import compose from 'lodash/fp/compose'
import { FAMILY_MEMBERS_COUNT } from '../constants/promo'
import { State } from 'shared/types/redux'

const SHARE_IMAGE =
  'https://a.bmstatic.com/iu/34/58/splash-bc718ae572a82ad2a03142107fb78281.png'

type Props = {
  currentUser: CurrentUserState
  i18n: any
  location: Location
} & DecoratorProps
class FamilySubscriptionLandingPage extends React.Component<Props> {
  render(): JSX.Element {
    const { currentUser, i18n, isMobileSize, location } = this.props

    const isRestrictedByRegion = !currentUser.data.family_plans_present

    // Lock landing (/family) only, not underlying invitation (/family/invite) routes
    if (isRestrictedByRegion && location.pathname === '/family') {
      return <SpecialOfferUnavailable />
    }

    return (
      <>
        <MetaTitle
          disableSuffix
          title={i18n._('family-subscription.landing_meta_title')}
        />
        <MetaDescription
          description={i18n._(
            'family-subscription.landing_meta_description_year',
            {
              maxMembers: FAMILY_MEMBERS_COUNT,
            },
          )}
        />
        <Meta content={SHARE_IMAGE} property="twitter:image" />
        <Meta content={SHARE_IMAGE} property="og:image" />
        <Meta content="summary_large_image" property="twitter:card" />
        <HeaderBox fixed={!isMobileSize()} custom="family" />
        <div className="family-subscription_wrapper">{this.props.children}</div>
      </>
    )
  }
}

const connectWrapper = connect((state: State) => ({
  currentUser: state.currentUser,
}))

export default compose(
  uiBox,
  connectWrapper,
  withI18n({ update: true }),
)(FamilySubscriptionLandingPage)
